import { apiRequest } from '@/api/client';
import type { SearchNetworkLine, SiteSearchView } from '@/types/api';

/** Google Search Console for a site (ADR-0049). */
export const searchConsoleApi = {
  network: () => apiRequest<SearchNetworkLine[]>('/search-console'),
  site: (siteId: string) => apiRequest<SiteSearchView>(`/sites/${siteId}/search-console`),
  connect: (siteId: string) => apiRequest<{ requested: boolean }>(`/sites/${siteId}/search-console`, { method: 'POST', body: {} }),
  recheck: (siteId: string) => apiRequest<{ requested: boolean }>(`/sites/${siteId}/search-console/recheck`, { method: 'POST', body: {} }),
  sync: (siteId: string) => apiRequest<{ requested: boolean }>(`/sites/${siteId}/search-console/sync`, { method: 'POST', body: {} }),
  disconnect: (siteId: string) => apiRequest<{ removed: boolean }>(`/sites/${siteId}/search-console`, { method: 'DELETE' }),
};
